import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-sticky-action-bar',
  templateUrl: './sticky-action-bar.component.html',
  styleUrls: ['./sticky-action-bar.component.scss'],
})
export class StickyActionBarComponent {
  @Input() selectionCount = 0;
  @Input() selectionCountText = '';
  @Input() primaryButtonText = '';
  @Input() isPrimaryButtonDisabled = false;
  @Input() dataCy = '';

  @Output() clearSelection = new EventEmitter<void>();
  @Output() primaryAction = new EventEmitter<void>();

  onClearSelection(): void {
    this.clearSelection.emit();
  }

  onPrimaryAction(): void {
    this.primaryAction.emit();
  }
}
